// «сегодня в 14:05», «вчера в 09:10», «12 окт. в 18:30» (год — только если не текущий)
export const formatRecent = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const time = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    const now = new Date();
    const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const days = Math.round((dayStart(now) - dayStart(date)) / 86400000);
    if (days === 0) return `сегодня в ${time}`;
    if (days === 1) return `вчера в ${time}`;
    const day = date.toLocaleDateString('ru-RU', {
        day: 'numeric', month: 'short', ...(date.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}),
    });
    return `${day} в ${time}`;
};
